/*global kakao*/
import React from "react";
import ReactDOM from "react-dom";
import { Map } from "ol";
import $ from "jquery";
import {
	defaults as DefaultControls,
	Zoom,
	ZoomSlider,
	//ScaleLine,
	// FullScreen,
} from "ol/control";
// import { OSM } from 'ol/source';
import { defaults as DefaultInteractions, DoubleClickZoom, DragPan, MouseWheelZoom } from "ol/interaction";
import { Tile as TileLayer, Vector } from "ol/layer";
//import { Projection, transform, transformExtent } from "ol/proj";
import { Projection, transform } from "ol/proj";
import { register } from "ol/proj/proj4";
//import { XYZ, WMTS } from "ol/source";
import { XYZ } from "ol/source";
import { Overlay } from "ol";
//import { Vector as VectorLayer } from "ol/layer";
import TileGrid from "ol/tilegrid/TileGrid";
import View from "ol/View";
// import { DEVICE_PIXEL_RATIO } from "ol/has";
//import proj from "ol/proj";
import proj4 from "proj4";
import html2canvas from "html2canvas";

import ReactHlsPlayer from "react-hls-player";

import css from "components/map/header/menu/mapMenu.module.scss";

export default class SisMap {
	constructor(props = {}) {
		if (!props.id) {
			alert("지도 Element ID 값을 설정하여 주세요");
			return false;
		}

		this.x = props.x;
		this.y = props.y;
		this.z = props.z;

		this.id = props.id;
		this.scaleId = props.scaleId;
		this.map = null;
		this.subMap = [];
		this.preBaseMap = "daum";
		this.view = null;
		this.crsCode = "EPSG:5181";
		this.zoom = 3;
		this.zoomSlider = props.zoomSlider ? props.zoomSlider : false;
		this.extent = [14078276.762476487, 4164778.206574664, 14153452.517433995, 4201716.839798583]; //광주 센터
		//this.extent = [13923514.918127995, 4020015.1947794533, 285105.0000004432, 322652.0000042608];
		this.center = [14117752.785029236, 4185572.024391857]; // 광주 센터 좌표
		//this.center = [14080424.619709337, 4137865.1255640355]; // 전남도청 센터 좌표

		// 다음지도 관련
		this.daumMapHidden = null;
		this.daumMap = null;
		this.daumHybrid = null;
		this.daumRoadView = null;
		this.daumSatellite = null;
		this.daumHybridvisibleCheck = true;

		// vworld 관련
		this.vworldMap = null;
		this.vworldSatellite = null;

		// 로드뷰 관련
		this.mapWalker = null;
		this.roadViewTarget = null;
		this.prePosition = null;
		this.sisRoadViewOverlay = null;

		// 센터점 주소를 불러올지 여부
		this.isCenterPosition = props.isCenterPosition ? props.isCenterPosition : false;

		// contextmenu
		this.isContextMenu = props.contextMenu ? props.contextMenu : false;
		this.contextMenu = null;
		this.contextClickCoord = null;

		this._setProjf();

		this.createMap();
		window.sis = this;
	}

	//좌표계 설정
	_setProjf = () => {
		proj4.defs(
			"EPSG:5181",
			// '+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs',
			"+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
			// "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +units=m +no_defs"
		);
		proj4.defs("EPSG:5185", "+proj=tmerc +lat_0=38 +lon_0=125 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5186", "+proj=tmerc +lat_0=38 +lon_0=127 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5187", "+proj=tmerc +lat_0=38 +lon_0=129 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5188", "+proj=tmerc +lat_0=38 +lon_0=131 +k=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +units=m +no_defs");
		proj4.defs("EPSG:5174", "+proj=tmerc +lat_0=38 +lon_0=127.0028902777778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +units=m +no_defs +towgs84=-115.80,474.99,674.11,1.16,-2.31,-1.63,6.43");
		proj4.defs("EPSG:5179", "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
		proj4.defs("EPSG:4019", "+proj=longlat +ellps=GRS80 +no_defs");

		register(proj4);
	};

	setCenter = (coord, coordEpsg, zoom = 12) => {
		this.view.setCenter(transform(coord, coordEpsg, this.crsCode));
		this.view.setZoom(zoom);
	};

	fullScreen = () => {
		document.getElementsByClassName("ol-full-screen")[0].firstElementChild.click();
	};

	fullExtent = () => {
		this.view.setCenter(transform(this.center, "EPSG:3857", this.crsCode));
		this.view.setZoom(this.zoom);
	};

	getCenter = (crsCode = "EPSG3857") => {
		return transform(this.view.getCenter(), this.crsCode, crsCode);
	};

	getPositionByCenter = (target, center) => {
		if (!(target && center)) return;

		$.ajax({
			url: "/map/getPositionByCenter/",
			type: "post",
			data: {
				x: center[0],
				y: center[1],
			},
			beforeSend: () => {
				return;
			},
			success: (res) => {
				if (res.sggNm) {
					$(target).text(`전남광주통합특별시 ${res.sggNm ? res.sggNm : ""} ${res.emdNm ? res.emdNm : ""} ${res.riNm ? res.riNm : ""}`);
				} else {
					$(target).text("-");
				}
			},
		});
	};

	setDaumHybridvisibleCheck = (value) => {
		this.daumHybridvisibleCheck = value;
		this.daumHybrid.setVisible(this.daumHybridvisibleCheck);
	}


	subMapClear = () => {
		let layers;
		let ele;

		this.subMap.forEach((map) => {
			layers = map.getLayers();

			layers.forEach((lyr) => {
				map.removeLayer(lyr);
			});

			ele = map.getTargetElement();
			$(ele).find(".ol-viewport").remove();
			map.setTarget(undefined);
		});

		this.subMap = [];
		$(`.sisSubMap`).hide();
		$(`#${this.id}`).removeClass("split");
		$(`#${this.id}, .sisSubMap`).removeClass("h50");
		this.map.updateSize();
	};

	createSubMap = (cnt = 2) => {
		const self = this;
		this.isSplit = true;
		this.subMapClear();

		$("#" + this.id).addClass("split");
		if (cnt > 2) {
			$("#" + this.id).addClass("h50");
			$(".sisSubMap").addClass("h50");
		}
		this.map.updateSize();

		let layers = this.map.getLayers();

		let idx = 0;
		for (var j = 2; j <= cnt; j++) {
			$(`#subMap${j}`).css({ display: "inline-block" });

			idx = j - 2;

			this.subMap[idx] = new Map({
				target: "subMap" + j,
				controls: DefaultControls({
					attribution: false,
					collapsible: false,
					zoom: false,
					rotate: false,
				}),
				interactions: DefaultInteractions({
					dragPan: false,
					mouseWheelZoom: false,
				}).extend([
					new DragPan({
						kinetic: false,
					}),
					new MouseWheelZoom({
						duration: 0,
					}),
					new DoubleClickZoom({
						duration: 0,
					}),
				]),
				view: this.map.getView(),
			});

			layers.forEach((lyr) => {
				const source = lyr.getSource();

				if (lyr instanceof TileLayer) {
					if (source instanceof XYZ) self.subMap[idx].addLayer(new TileLayer(lyr.getProperties()));
				}
			});
			this.subMap[idx].addLayer(this.daumHybrid);
		}
	};

	// 맵 생성
	createMap = () => {
	

		this.map = new Map({
			target: this.id,
			controls: DefaultControls({
				attribution: false,
				collapsible: false,
				zoom: false,
				rotate: false,
			}).extend(
				this.zoomSlider
					? [
							new Zoom({
								duration: 0,
							}),
							new ZoomSlider(),
					  ]
					: []
			),
			view: new View(),
			// view: this.view,
			interactions: DefaultInteractions({
				dragPan: false,
				mouseWheelZoom: false,
				doubleClickZoom: true,
				pinchRotate: false,
				altShiftDragRotate: false,
			}).extend([
				new DragPan({
					kinetic: false,
				}),
				new MouseWheelZoom({
					duration: 0,
					constrainResolution: true
				}),
			]),
		});

		
		this.map.set("contextMenu", true);

		this.changeBaseMap("daum");
		this._addDaum(true);
		this._addVwold(false);

		const self = this;

		if (this.isContextMenu) {
			// 오버레이 생성
			this.contextMenu = new Overlay({
				element: document.querySelector("#sisContextMenu"),
				offset: [5, -17],
				positioning: "top-left",
				// stopEvent: false,
			});

			this.map.addOverlay(this.contextMenu);

			document.querySelector("#sisContextMenu").onblur = (e) => {
				$(e.target).hide();
			};

			this.map.getViewport().addEventListener("contextmenu", function (e) {
				e.preventDefault();
				const coordinate = self.map.getCoordinateFromPixel([e.layerX, e.layerY]);

				if (self.map.get("contextMenu")) {
					self.contextMenu.setPosition(coordinate);
					self.contextClickCoord = coordinate;

					$("#sisContextMenu").show();
					$("#sisContextMenu").attr("tabindex", -1).focus();
				}
			});
		} else {
			this.map.getViewport().addEventListener("contextmenu", function (e) {
				e.preventDefault();
			});
		}

		//this.view.on("change:resolution", (evt) => {
		//	if (this.scaleId) {
		//		const items = $("#" + this.scaleId).find(".item");
		//		const cnt = items.length - 1;
		//		const zoom = evt.target.getZoom();
		//		const $selected = $(items[cnt - zoom]);
		//		const $text = $("#" + this.scaleId + " .text:first");

		//		items.removeClass("active").removeClass("selected");

		//		$selected.addClass("active").addClass("selected");

		//		$text.text($selected.text());
		//	}
		//});

		if (this.isCenterPosition) {
			this.map.on("moveend", (evt) => {
				let center = transform(this.view.getCenter(), this.crsCode, "EPSG:5186");
				this.getPositionByCenter("#centerPosition", center);

				// console.log(11 - this.view.getZoom());
			});
		}

		this.map.on("click", (e) => {
			const overlay = this.map.getOverlayById("overlaySelector");
			if (overlay) this.map.removeOverlay(overlay);

			let feature = this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
				return feature;
			});

			if (feature && feature.get("type")) {
				if (feature.get("type") === "cctv") {
					let width = 340;
					let height = 321;
					let top = (window.screen.height - height) / 2;
					let left = (window.screen.width - width) / 2;

					let features = "width=" + width + ",height=" + height + ",top=" + top + ",left=" + left + ",toolbar=no,scrollbars=no,status=no,location=no";

					window.viewCctv = feature.getProperties().cctv;

					// 리버스 프록시 등록후 주석해제
					// window.open(
					// 	`/view/map/cctvStream.jsp?id=${feature.get("id")}&cctvid=${feature.get("cctvId")}&cctvname=${encodeURI(encodeURIComponent(feature.get("cctvName")))}&kind=${feature.get("kind")}&cctvch=${feature.get(
					// 		"cctvch"
					// 	)}&cctvip=${feature.get("cctvIp")}&cctvpasswd=${feature.get("cctvPasswd")}&cctvport=${feature.get("cctvPort")}`,
					// 	"UTIC도시교통정보센터",
					// 	features
					// );

					// 리버스 프록시 등록전 임시방편
					window.open(
						`http://www.utic.go.kr/view/map/cctvStream.jsp?id=${feature.get("id")}&cctvid=${feature.get("cctvId")}&cctvname=${encodeURI(encodeURIComponent(feature.get("cctvName")))}&kind=${feature.get("kind")}&cctvch=${feature.get(
							"cctvch"
						)}&cctvip=${feature.get("cctvIp")}&cctvpasswd=${feature.get("cctvPasswd")}&cctvport=${feature.get("cctvPort")}`,
						"UTIC도시교통정보센터",
						features
					);

					// var cctvPop = window.open(
					// 	`http://www.utic.go.kr/view/map/cctvStream.jsp?id=${feature.get("id")}&cctvid=${feature.get("cctvId")}&cctvname=${encodeURI(encodeURIComponent(feature.get("cctvName")))}&kind=${feature.get("kind")}&cctvch=${feature.get(
					// 		"cctvch"
					// 	)}&cctvip=${feature.get("cctvIp")}&cctvpasswd=${feature.get("cctvPasswd")}&cctvport=${feature.get("cctvPort")}`,
					// 	"PopupCctv",
					// 	"top=" + top + "left=" + left + ",width=" + width + "px, height=" + height + "px, menubar=no, location=no, toolbar=no, scrollbars=no, status=no, resizable=no"
					// );

					//http://www.utic.go.kr/view/map/cctvStream.jsp?C&kind=v&cctvip=null&cctvch=72&id=10&cctvpasswd=213&cctvport=null&minX=126.73056955231097&minY=35.08479633142551&maxX=127.0775677881888&maxY=35.222551342070666

					// console.log(cctvPop);
					// ReactDOM.render(
					// 	<iframe
					// 		src={`http://www.utic.go.kr/view/map/cctvStream.jsp?id=${feature.get("id")}&cctvid=${feature.get("cctvId")}&cctvname=${encodeURI(encodeURIComponent(feature.get("cctvName")))}&kind=${feature.get(
					// 			"kind"
					// 		)}&cctvch=${feature.get("cctvch")}&cctvip=${feature.get("cctvIp")}&cctvpasswd=${feature.get("cctvPasswd")}&cctvport=${feature.get("cctvPort")}`}
					// 		style={{ width: "340px", height: "321px" }}
					// 	/>,
					// 	$("#cctvVideo")[0]
					// );

					// $("#cctvModal").css({
					// 	width: "380px",
					// 	height: "467px",
					// });
					// $(".cctvJibunValue").text(feature.get("cctvName"));

					// ReactDOM.render(<ReactHlsPlayer url={"http://118.40.176.110:1935/live/WCAM0050.stream/playlist.m3u8"} autoplay={true} controls={true} width={"100%"} height={"auto"} />, $("#cctvVideo")[0]);

					// var iframe = document.getElementById("cctvIFrame").contentWindow;
					// iframe.window.opener = window;
				} else {
					ReactDOM.render(<ReactHlsPlayer url={feature.get("cctvUrl")} autoplay={true} controls={true} width={"100%"} height={"auto"} />, $("#cctvVideo")[0]);

					$("#cctvModal").css({
						width: "400px",
						height: "390px",
					});
					$(".cctvJibunValue").text(feature.get("cctvName"));
				}

				// $("#cctvModal").show();
			}
		});

		this.map.on("pointermove", (e) => {
			if (e.dragging) {
				// $(element).popover("dispose");
				$(".myPos").removeClass(css.active);
				return;
			}
			var hit = this.map.hasFeatureAtPixel(e.pixel);
			this.map.getTargetElement().style.cursor = hit ? "pointer" : "";
		});

		if (this.x && this.y) this.view.setCenter([parseFloat(this.x), parseFloat(this.y)]);
	};

	// 베이스맵 설정
	changeBaseMap = (id) => {
		if (!id) return;

		var changeView = this.getView(id);

		this.map.setView(changeView);
		this.view = changeView;

		this.transformFeature();
		this.preBaseMap = id.toLowerCase();
	};

	// View 생성
	getView = (id) => {
		var view;
		var config = this.getBaseMap(id);

		var zoom = this.map.getView().getZoom() ? this.map.getView().getZoom() : this.zoom;
		var preCenter;

		if (!this.map.getView().getCenter()) {
			preCenter = transform(this.center, "EPSG:3857", config.projection);
		} else {
			preCenter = transform(this.view.getCenter(), this.crsCode, config.projection);
		}

		// var projection = new Projection({
		// 	code: 'EPSG:5181',
		// 	units: '',
		// 	axisOrientation: 'neu'
		// });

		view = new View({
			projection: config.projection,
			center: preCenter,
			resolutions: config.resolutions,
			zoom: zoom,
			constrainResolution: true,
			zoomFactor: 1,
			minZoom: 3,
			maxZoom: 13,

			// projection: projection,
			// center: [0, 0],
			// extent: config.extent,
			// resolutions: config.resolutions,
			// zoomFactor: 1,
			// minZoom: 3,
			// maxZoom: 13,
		});

		// this.map.getView().fit([22199.999999998254,56146.999909237435,285104.99999956193,222646.999904314], this.map.getSize());

		view.on("change:resolution", (evt) => {
			if (this.scaleId) {
				$.each($(".mapScaleWrap"), (idx, item) => {
					const items = $(item).find(".item");
					const cnt = items.length - 1;
					const zoom = Math.floor(evt.target.getZoom());
					const $selected = $(items[cnt - zoom]);
					const $text = $(item).find(".text:first");

					items.removeClass("active").removeClass("selected");

					$selected.addClass("active").addClass("selected");

					$text.text($selected.text());
				});
			}
		});

		this.crsCode = config.projection;

		return view;
	};

	// 베이스맵 config 가져오기
	getBaseMap = (id) => {
		var baseMap;

		if (id.toLowerCase() === "vworld") {
			baseMap = {
				id: "VWorld",
				name: "VWorld",
				korName: "브이월드",
				projection: "EPSG:3857",
				tileSize: 256,
				center: [14121043.79, 4185661.96],
				extent: [14098021.61, 4170799.78, 14140057.41, 4199108.25],
				//					resolutions : [38.218514142588134, 19.109257071294067, 9.554628535647034, 4.777314267823517, 2.3886571339117584, 1.1943285669558792, 0.5971642834779396, 0.2985821417389698, 0.1492910708694849, 0.0746455354347425],
				resolutions: [2445.98490512564, 1222.99245256282, 611.49622628141, 305.748113140705, 152.8740565703525, 76.43702828517625, 38.21851414258813, 19.109257071294063, 9.554628535647032, 4.777314267823516, 2.388657133911758],
				//					resolutions : [ 38.21851414258813, 76.43702828517625, 152.8740565703525, 305.748113140705, 611.49622628141, 1222.99245256282, 2445.98490512564 ],
			};
		} else if (id.toLowerCase() === "daum") {
			baseMap = {
				id: "Daum",
				name: "Daum",
				korName: "다음",
				projection: "EPSG:5181",
				tileSize: 256,
				center: [186469.67, 184868.86],
				origin: [-30000, -60000],
				extent: [-30000 - Math.pow(2, 19) * 4, -60000, -30000 + Math.pow(2, 19) * 5, -60000 + Math.pow(2, 19) * 5],
				resolutions: [256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],

				// extent: [-30000, -60000, 494288, 988576],
				// resolutions: [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],
			};
		} else if (id.toLowerCase() === "naver") {
			baseMap = {
				id: "Naver",
				name: "Naver",
				korName: "네이버",
				projection: "EPSG:5179",
				tileSize: 256,
				center: [940937.89, 1685177.3],
				extent: [90112, 1192896, 1990673, 2765760],
				resolutions: [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],
			};
		}

		return baseMap;
	};

	// 베이스맵 변경시 모든 피쳐 Projection 변경
	transformFeature = () => {
		var self = this;
		var preCrsCode = this.getBaseMap(this.preBaseMap).projection;

		this.map.getLayers().forEach(function (layer) {
			if (layer instanceof Vector) {
				layer
					.getSource()
					.getFeatures()
					.forEach(function (feature) {
						feature.getGeometry().transform(preCrsCode, self.props.crsCode);
					});
			}
		});
	};

	// 다음지도 불러오기
	_addDaum = (visible) => {
		// 직접 불러오기
		var config = this.getBaseMap("daum");

		var resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
		var extent = config.extent;
		var origin = config.origin;
		var projection = new Projection({
			code: config.projection,
			extent: extent,
			units: "m",
		});

		// var resolutions = [256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
		// var extent      = [-30000, -60000, 494288, 988576];
		// var origin = [extent[0], extent[1]];
		//
		// var projection = new Projection({
		// 	code: "EPSG:5181",
		// 	extent: extent,
		// 	units: "m",
		// });

		// define tile layer
		this.daumMap = new TileLayer({
			id: "Daum",
			title: "Daum Street Map",
			visible: true,
			type: "base",
			zIndex: -1,
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				zDirection: -1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					if (tileCoord[0] >= 14) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;

					//return "https://mts.daumcdn.net/api/v1/tile/PNGSD02/v11_hdwvr/latest/"+ z + "/" + -y + "/" + x + ".png";
					//return "https://mts.daumcdn.net/api/v1/tile/PNGSD02/v13_72nww/latest/"+ z + "/" + -y + "/" + x + ".png";
					//return "https://mts.daumcdn.net/api/v1/tile/PNGSD02/v14_3hrdp/latest/"+ z + "/" + -y + "/" + x + ".png";
					return "https://mts.daumcdn.net/api/v1/tile/PNGSD02/v20_9nuhw/latest/"+ z + "/" + -y + "/" + x + ".png";
				},
				imageSmoothing: false,
			}),
		});

		this.daumSatellite = new TileLayer({
			id: "DaumSatellite",
			title: "Daum Satellite",
			visible: false,
			type: "base",
			zIndex: -1,
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;

					return "https://map" + s + ".daumcdn.net/map_skyview/L" + z + "/" + -y + "/" + x + ".jpg?v=160114";
				},
				imageSmoothing: false,
			}),
		});

		this.daumHybrid = new TileLayer({
			id: "DaumHybrid",
			title: "Daum Hybrid",
			visible: false,
			type: "base",
			zIndex: 0,
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 3,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;

					return "https://map" + s + ".daumcdn.net/map_hybrid/2205pfk/L" + z + "/" + -y + "/" + x + ".png";
				},
				imageSmoothing: false,
			}),
		});

		this.daumRoadView = new TileLayer({
			id: "roadview",
			title: "roadview",
			visible: false,
			type: "base",
			zIndex: 1,
			source: new XYZ({
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					origin: origin,
					resolutions: resolutions,
				}),
				tileUrlFunction: function (tileCoord, pixelRatio, projection) {
					if (tileCoord == null) return undefined;
					var s = Math.floor(Math.random() * 4); // 0 ~ 3
					var z = resolutions.length - tileCoord[0];
					var x = tileCoord[1];
					var y = tileCoord[2] + 1;
					return "https://map" + s + ".daumcdn.net/map_roadviewline/7.00/L" + z + "/" + -y + "/" + x + ".png";
				},
			}),
		});


		this.map.addLayer(this.daumMap);
		this.map.addLayer(this.daumSatellite);
		this.map.addLayer(this.daumHybrid);
		this.map.addLayer(this.daumRoadView);
	};

	_addDaumClear = () => {
		const map = this.map;
		map.removeLayer(this.daumHybrid);
	};

	_addDaumHybrid = () => {
		const map = this.map;
		map.addLayer(this.daumHybrid);
	};

	kakaoHybrid = () => {
		this.daumHybrid.setVisible(true);
		this.daumSatellite.setVisible(true);
		this.daumMap.setVisible(false);
		//this.vworldMap.setVisible(false);
		//this.vworldSatellite.setVisible(false);

	};

	kakaoNormal = () => {
		this.daumSatellite.setVisible(false);
		// this.daumRoadView.setVisible(false);
		this.daumHybrid.setVisible(false);
		this.daumMap.setVisible(true);
		//this.vworldMap.setVisible(false);
		//this.vworldSatellite.setVisible(false);
	};

	kakaoNone = () => {
		this.daumSatellite.setVisible(false);
		// this.daumRoadView.setVisible(false);
		this.daumHybrid.setVisible(false);
		this.daumMap.setVisible(false);
		//this.vworldMap.setVisible(false);
		//this.vworldSatellite.setVisible(false);
	};

	// 브이월드지도 불러오기
	_addVwold = (visible) => {
		// 직접 불러오기
		var config = this.getBaseMap("vworld");

		var resolutions = [2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25];
		var extent = config.extent;
		//var origin = config.origin;
		var projection = new Projection({
			code: config.projection,
			extent: extent,
			units: "m",
		});
		//mapLayer = new ol.layer.Tile({ //타일 생성
	//		title : 'Vworld Map', //이름
	//		visible : true, //보여짐 여부
	//		type : 'base', //지도 종류(일반) ---(야간(midnight), 위성(satellite) 등)
	//		source : new ol.source.XYZ({ //vworld api 사용
	//			url : 'http://api.vworld.kr/req/wmts/1.0.0/{api키}/Base/{z}/{y}/{x}.png'
	//		})
	//	});
		this.vworldMap = new TileLayer({
			id: "Vworld",
			title: "Vworld Street Map",
			visible: visible,
			type: "base",
			zIndex: -1,
			source : new XYZ({ //vworld api 사용
				//url : 'https://api.vworld.kr/req/wmts/1.0.0/FE9D6FCF-D095-3C30-99E0-DB587D3BFF41/Base/{z}/{x}/{y}.png',
				url : 'https://api.vworld.kr/req/wmts/1.0.0/22ACAE3E-B16B-34F6-8078-5FB44F80FA5E/Base/{z}/{x}/{y}.png',
				projection: projection,
				//tileSize: 256,
				minZoom: 10,
				maxZoom: 19,
				//tileGrid: new TileGrid({
				//	resolutions: resolutions,
				//}),
			})
		});
	/*		this.vworldMap = new TileLayer({
			id: "Vworld",
			title: "Vworld Street Map",
			visible: visible,
			type: "base",
			zIndex: -1,
			source: new XYZ({
				url : 'https://api.vworld.kr/req/wmts/1.0.0/FE9D6FCF-D095-3C30-99E0-DB587D3BFF41/Base/{z}/{x}/{y}.png',
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				zDirection: -1,
				tileGrid: new TileGrid({
					resolutions: resolutions,
				}),
			}),
		});*/

		/*this.vworldSatellite = new TileLayer({ 
			id: "VworldSatellite",
			title: "Vworld Satellite",
			visible: visible,
			type: "base",
			zIndex: -1,
			source: new XYZ({
				url :  'https://api.vworld.kr/req/wmts/1.0.0/FE9D6FCF-D095-3C30-99E0-DB587D3BFF41/Satellite/{z}/{x}/{y}.png',
				projection: projection,
				tileSize: 256,
				minZoom: 0,
				maxZoom: resolutions.length - 1,
				tileGrid: new TileGrid({
					resolutions: resolutions,
				}),
			}),
		});*/

		this.map.addLayer(this.vworldMap);
		//this.map.addLayer(this.vworldSatellite);
	};

	vworldNormal = () => {
		this.daumSatellite.setVisible(false);
		this.daumHybrid.setVisible(false);
		this.daumMap.setVisible(false);
		this.vworldMap.setVisible(true);
		this.vworldSatellite.setVisible(false);
	};

	vworldNone = () => {
		this.daumSatellite.setVisible(false);
		this.daumHybrid.setVisible(false);
		this.daumMap.setVisible(false);
		this.vworldMap.setVisible(false);
		this.vworldSatellite.setVisible(false);
	};

	mapExport = () => {
		const self = this;

		this.map.once("postcompose", function (event) {
			html2canvas(self.map.getTargetElement(), {
				useCORS: true,
				proxy: "https://github.com/niklasvh/html2canvas-proxy-nodejs/blob/master/server.js",
			}).then(function (canvas) {
				if (navigator.msSaveBlob) {
					navigator.msSaveBlob(canvas.msToBlob(), "map.png");
				} else {
					canvas.toBlob(function (blob) {
						var url = URL.createObjectURL(blob);

						var a = document.createElement("a");
						a.download = "map.png";
						a.href = url;
						a.click();
					});
				}
			});
		});
		this.map.renderSync();
	};

	roadViewInit = (target) => {
		this.roadViewTarget = target;

		this.overlayElement = document.createElement("div");
		this.overlayElement.className = "roadViewPointer";

		if (this.overlayRoadViewLayer) {
			this.map.removeOverlay(this.overlayRoadViewLayer);
		}

		this.overlayRoadViewLayer = new Overlay({
			element: this.overlayElement,
			offset: [0, 0],
			stopEvent: false,
			positioning: "bottom-center",
		});
		this.map.addOverlay(this.overlayRoadViewLayer);

		this.map.un("click", this.roadViewClickEvent);
		this.map.un("pointermove", this._pointerMove);

		this.map.on("click", this.roadViewClickEvent);
		this.map.on("pointermove", this._pointerMove);
		$(`#${this.id}`).on("mouseleave", this.hideRoadViewPointer);
		$(`#${this.id}`).on("mouseenter", this.showRoadViewPointer);
	};

	hideRoadViewPointer = () => {
		$(".roadViewPointer").hide();
	};

	showRoadViewPointer = () => {
		$(".roadViewPointer").show();
	};

	roadView = (target, coord) => {
		$('.roadViewClose').show();
		if (this.mapWalker) {
			this.getFakeRoadView(target, coord);

			$(".sisMapWalker").show();

			return false;
		}

		if (this.sisRoadViewOverlay) {
			this.map.removeOverlay(this.sisRoadViewOverlay);
		}

		if (this.overlayRoadViewLayer) {
			this.map.removeOverlay(this.overlayRoadViewLayer);
		}

		this.sisRoadViewOverlay = new Overlay({
			element: document.querySelector(".sisMapWalker"),
			offset: [0, 0],
			stopEvent: false,
		});
		// 오버레이 생성
		this.map.addOverlay(this.sisRoadViewOverlay);

		// 다음 API 사용
		const script = document.createElement("script");
		script.async = true;
		//script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=ded2cb7b368dac7a9d38af9609620be7&autoload=false";
		//script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=204aa8ca517b41fa6fe621fe909a268f&autoload=false";
		script.src = "https://dapi.kakao.com/v2/maps/sdk.js?appkey=c3304e9903001cd388af7216b702f7fa&autoload=false";
		document.head.appendChild(script);

		// 로드뷰를 위한 hidden 다음맵
		script.onload = () => {
			kakao.maps.load(() => {
				let center = transform(this.center, "EPSG:3857", "EPSG:4326");
				var container = document.getElementById("daumMap");
				var options = {
					center: new kakao.maps.LatLng(center[1], center[0]),
					level: 14 - this.zoom,
				};

				this.daumMapHidden = new kakao.maps.Map(container, options); //지도 생성
				this.getFakeRoadView(target, coord);

				// this.map.un("click", this.roadViewClickEvent);
				// this.map.on("click", this.roadViewClickEvent);
			});
		};
		
	};

	getFakeRoadView = (target, coord) => {
		const self = this;

		var roadview = new kakao.maps.Roadview(target);
		target.style.display = "block";
		var roadviewClient = new kakao.maps.RoadviewClient();
		var position = new kakao.maps.LatLng(coord[1], coord[0]);
		var olPos = transform([parseFloat(coord[0]), parseFloat(coord[1])], "EPSG:4326", this.crsCode);

		//로드뷰 생성
		roadviewClient.getNearestPanoId(position, 100, function (panoId) {
			//const oriPosition = self.sisRoadViewOverlay.getPosition();

			if (panoId) {
				//$($(target).find("object")[0]).remove();
				//$(target).find("div:not(.close)").remove();

				self.daumRoadView.setVisible(true);
				roadview.setPanoId(panoId, position);

				olPos = transform([position.getLng(), position.getLat()], "EPSG:4326", self.crsCode);
				self.sisRoadViewOverlay.setPosition(olPos);
				self.setCenter(olPos, self.crsCode);
				self.setDetailZoom();
			} else {
				alert("로드뷰가 존재하지 않는 위치입니다.");
				$(target).find("div:not(.close)").remove();
				self.sisRoadViewOverlay.setPosition(self.prePosition);

				$(".btnRoadView").click();

				// closeRoadView(target);
			}
		});

		// 로드뷰 컨트롤러 생성
		kakao.maps.event.addListener(roadview, "init", function () {
			if (!self.mapWalker) self.mapWalker = new FakeMapWalker(position);
			self.mapWalker.setMap(this.daumMapHidden);
			$(".sisMapWalker").show();

			kakao.maps.event.addListener(roadview, "viewpoint_changed", function () {
				// 이벤트가 발생할 때마다 로드뷰의 viewpoint값을 읽어, map walker에 반영
				var viewpoint = roadview.getViewpoint();
				self.mapWalker.setAngle(viewpoint.pan);
				console.log("aaa");
				roadview.relayout();
			});

			kakao.maps.event.addListener(roadview, "position_changed", function () {
				// 이벤트가 발생할 때마다 로드뷰의 position값을 읽어, map walker에 반영
				var position = roadview.getPosition();
				self.mapWalker.setPosition(position);

				olPos = transform([position.getLng(), position.getLat()], "EPSG:4326", self.crsCode);
				self.sisRoadViewOverlay.setPosition(olPos);
				self.setCenter(olPos, self.crsCode);
			});
		});

		setTimeout(() => {
			this.map.updateSize();
		}, 100);
	};

	removeRoadViewObject = (target) => {
		$(target).hide();
		$(target).find("object").remove();
		$(target).find("div:not(.close)").remove();
	};

	closeRoadView = (target, isAllClear) => {
		if (!isAllClear) return false;
		this.daumRoadView.setVisible(false);
		//if (this.sisRoadViewOverlay) this.map.removeOverlay(this.sisRoadViewOverlay);

		$(".sisMapWalker, .mobile").hide();

		//
		$(this.map.getTargetElement()).parent().css({ right: "0" });
		this.removeRoadViewObject(target);

		this.map.un("click", this.roadViewClickEvent);
		this.map.un("pointermove", this._pointerMove);

		$(`#${this.id}`).off("mouseleave", this.hideRoadViewPointer);
		$(`#${this.id}`).off("mouseenter", this.showRoadViewPointer);

		$(".roadViewPointer").hide();

		this.map.updateSize();
	};

	setDetailZoom = () => {
		this.view.setZoom(10);
	};

	roadViewClickEvent = (e) => {
		var self = this;
		if (self.sisRoadViewOverlay) {
			self.prePosition = self.sisRoadViewOverlay.getPosition();

			//const olPos = transform(e.coordinate, self.crsCode, "EPSG:4326");
			self.sisRoadViewOverlay.setPosition(e.coordinate);
		}

		let coord = transform(e.coordinate, self.view.getProjection().getCode(), "EPSG:4326");

		this.roadView(self.roadViewTarget, coord);

		$("#mapNumber").hide();
		$(".sisMapWrap").css({
			zIndex: 9999,
			width: "320px",
			height: "200px",
			left: 0,
			bottom: 0,
			top: "auto",
			position: "absolute",
		});

		$("#map").css({ border: "2px solid #fff" });

		$(`.roadViewHidden, .footer`).hide();
		$(`.ol-overlaycontainer-stopevent`).hide();

		$(".mapRight.menu").hide();
		$("#previewWrap").hide();
		$(".currentArea").hide();
	};

	_pointerMove = (e) => {
		this.overlayRoadViewLayer.setPosition(e.coordinate);
	};
}

//지도위에 현재 로드뷰의 위치와, 각도를 표시하기 위한 map walker 아이콘 생성 클래스
function FakeMapWalker(position) {
	//커스텀 오버레이에 사용할 map walker 엘리먼트
	var content = document.createElement("div");
	var figure = document.createElement("div");
	var angleBack = document.createElement("div");

	//map walker를 구성하는 각 노드들의 class명을 지정 - style셋팅을 위해 필요
	content.className = "sisMapWalker";
	figure.className = "figure";
	angleBack.className = "angleBack";

	content.appendChild(angleBack);
	content.appendChild(figure);

	//커스텀 오버레이 객체를 사용하여, map walker 아이콘을 생성
	var walker = new kakao.maps.CustomOverlay({
		position: position,
		content: content,
		yAnchor: 1,
	});

	this.walker = walker;
	this.content = content;
}

//로드뷰의 pan(좌우 각도)값에 따라 map walker의 백그라운드 이미지를 변경 시키는 함수
//background로 사용할 sprite 이미지에 따라 계산 식은 달라 질 수 있음
FakeMapWalker.prototype.setAngle = function (angle) {
	var threshold = 22.5; //이미지가 변화되어야 되는(각도가 변해야되는) 임계 값
	for (var i = 0; i < 16; i++) {
		//각도에 따라 변화되는 앵글 이미지의 수가 16개
		if (angle > threshold * i && angle < threshold * (i + 1)) {
			//각도(pan)에 따라 아이콘의 class명을 변경
			var className = "m" + i;
			this.content.className = this.content.className.split(" ")[0];
			this.content.className += " " + className;
			$(".sisMapWalker").attr("class", this.content.className);
			break;
		}
	}
};

//map walker의 위치를 변경시키는 함수
FakeMapWalker.prototype.setPosition = function (position) {
	this.walker.setPosition(position);
};

//map walker를 지도위에 올리는 함수
FakeMapWalker.prototype.setMap = function (map) {
	this.walker.setMap(map);
};
